import adapter from 'garaje/utils/decorators/adapter';

import EmployeeGroupModel from './employee-group';

@adapter('v3-coalesce')
class OrganizationEmployeeGroupModel extends EmployeeGroupModel {}

export default OrganizationEmployeeGroupModel;

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'organization-employee-group': OrganizationEmployeeGroupModel;
  }
}
